import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { green } from "@mui/material/colors";
import Confetti from "react-confetti";
const Icon = "/images/timely365-icon.png";


const faqs = [
  {
    question: "How do I upgrade/downgrade my plan?",
    answer: "You can upgrade/downgrade your plan in the 'My bussiness -> Subscription & Billing' settings.",
  }
];

const SubscriptionSuccessPage = () => {
  const { planName } = useParams();
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [runConfetti, setRunConfetti] = useState(true);


  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    const confettiTimeout = setTimeout(() => {
      setRunConfetti(false);
    }, 5000); // 5 seconds

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(confettiTimeout);
    };
  }, []);


  return (
    <>
      {runConfetti && <Confetti width={width} height={height} />}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "30px 0",
        }}
      >
        <img
          onClick={() => {
            window.location.href = "/biz/bookingtypes?v=booking";
          }}
          src={Icon}
          style={{ margin: 0, width: "200px", cursor: "pointer" }}
        />
      </div>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        p={2}
        position="relative"
      >
        <CheckCircleIcon style={{ fontSize: 100, color: green[500] }} />
        <Typography variant="h4" gutterBottom>
          Subscription Successful!
        </Typography>
        <Typography variant="h5" gutterBottom>
          You've subscribed to the {planName} Plan
        </Typography>
        {/* <Typography variant="h6" gutterBottom>
          Plan Features:
        </Typography>
        <List>
          {plan.features.map((feature, index) => (
            <ListItem key={index}>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List> */}
        <Typography variant="h6" gutterBottom>
          FAQs:
        </Typography>
        <List>
          {faqs.map((faq, index) => (
            <ListItem key={index}>
              <ListItemText primary={faq.question} secondary={faq.answer} />
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
};

export default SubscriptionSuccessPage;
